var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "lommebok",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4211 13.4249C17.4316 13.4249 18.3158 12.541 18.3158 11.5308C18.3158 10.5207 17.4316 9.63676 16.4211 9.63676C15.4105 9.63676 14.5263 10.5207 14.5263 11.5308C14.5263 12.541 15.2842 13.4249 16.4211 13.4249ZM11.3684 16.5816V6.48001H24V16.5816H11.3684ZM22.7368 19.107V20.3697C22.7368 21.7587 21.6 22.8951 20.2105 22.8951H2.52632C1.13684 22.8951 0 21.7587 0 20.3697V2.69191C0 1.30294 1.13684 0.166504 2.52632 0.166504H20.2105C21.6 0.166504 22.7368 1.30294 22.7368 2.69191V3.95461H11.3684C9.97895 3.95461 8.8421 5.09104 8.8421 6.48001V16.5816C8.8421 17.9706 9.97895 19.107 11.3684 19.107H22.7368Z",
    fill: "#0375D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ac312a2f.svg";
export { ForwardRef as ReactComponent };